import {
  GET_LIMITED_NOTIFICATIONS_REQUEST,
  GET_LIMITED_NOTIFICATIONS_SUCCESS,
  GET_LIMITED_NOTIFICATIONS_FAIL,
} from "../../types/admin/limitedNotisTypes";

export const limitedNotificationsReducer = (
  state = { notifications: [] },
  action
) => {
  switch (action.type) {
    case GET_LIMITED_NOTIFICATIONS_REQUEST:
      return { loading: true, notifications: [] };

    case GET_LIMITED_NOTIFICATIONS_SUCCESS:
      return { loading: false, notifications: action.payload };

    case GET_LIMITED_NOTIFICATIONS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
